// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608172304/js/" + chunkId + "." + {"44":"28992d60","225":"cc853420","481":"7fc22526","486":"a1441ea8","770":"96b850ee"}[chunkId] + ".0.39567583465921585.chunk.js";
};